import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 text-[#D6C5B3]"
      style={{ background: "#2E3630" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5 space-y-6">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full" style={{ background: "#6B8E7B" }}>
              <span className="font-serif-display text-white text-xl leading-none">jf</span>
            </span>
            <div>
              <p className="font-serif-display text-2xl text-white leading-tight">Jeremy Fuerte, LCSW</p>
              <p className="eyebrow text-[10px] text-[#D6C5B3]">Trauma-informed Therapy · Denver, CO</p>
            </div>
          </div>
          <p className="font-body text-sm leading-relaxed text-[#C4B7A5] max-w-md">
            A quiet, considered space for individuals navigating PTSD, anxiety,
            and depression — including veterans and the LGBTQ+ community.
          </p>
          <Link
            to="/contact"
            data-testid="footer-book-cta"
            className="btn-pill btn-primary w-fit"
          >
            Request a consultation
          </Link>
        </div>

        <div className="lg:col-span-3 space-y-4">
          <p className="eyebrow text-[#6B8E7B]">Practice</p>
          <ul className="space-y-3 font-body text-sm">
            <li><Link to="/about" className="hover:text-white transition-colors" data-testid="footer-link-about">About Jeremy</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4 space-y-4">
          <p className="eyebrow text-[#6B8E7B]">Location</p>
          <p className="font-body text-sm text-[#C4B7A5] leading-relaxed">
            2560 Sheridan Blvd.<br />
            Denver, CO 80214
          </p>
          <p className="eyebrow text-[#6B8E7B] pt-4">Phone</p>
          <p className="font-body text-sm text-[#C4B7A5] leading-relaxed">
            <a href="tel:+17204774692" className="hover:text-white transition-colors">(720) 477-4692</a>
          </p>
          <p className="eyebrow text-[#6B8E7B] pt-4">Hours</p>
          <p className="font-body text-sm text-[#C4B7A5] leading-relaxed">
            Monday – Thursday · 11 AM – 8 PM<br />
            Friday & Saturday · By appointment only<br />
            Sunday · Closed
          </p>
          <div className="mt-6 p-5 rounded-2xl border border-[#3F4A42] bg-[#374038]">
            <div className="flex items-center gap-2 text-[#D6C5B3]">
              <AlertCircle size={16} className="text-[#B06E66]" />
              <p className="eyebrow text-[10px]">If you're in crisis</p>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-[#C4B7A5]">
              Call or text <span className="text-white">988</span> (Suicide & Crisis Lifeline).
              Veterans: press 1. For an emergency, call 911.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-[#3F4A42]">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row gap-3 sm:justify-between text-xs font-body text-[#9AA39C]">
          <span>© {new Date().getFullYear()} Jeremy Fuerte, LCSW. Licensed Clinical Social Worker, Colorado.</span>
          <span>This site is not a substitute for emergency care.</span>
        </div>
      </div>
    </footer>
  );
}
